import { render, staticRenderFns } from "./corporateLomSideView.vue?vue&type=template&id=61ced131"
import script from "./corporateLomSideView.vue?vue&type=script&lang=js"
export * from "./corporateLomSideView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports